/*
|--------------------------------------------------------------------------
| Analytics: Salesforce
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.salesforce = {
	"init": function(){
		if (this.isDisabled()) {return;}
		this.loadLibrary();
		this.trackDefault();
	},
	
	/**
	 * Disabled check
	 */
	"isDisabled": function(){
		var commonJS = __gh__webApp.common;
		return (!commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"analytics.salesforce.id"));	
	},
	
	
	/**
	 * Preload object
	 */
	"preload": {
		"eventQueue": [],
		"loaded": false
	},
	
	
	/**
	 * Onload fires when library is loaded
	 */
	 "onload": function(){
		var commonJS				= __gh__webApp.common,
			thisObj					= __gh__webApp.analytics.salesforce,
			eventQueue				= thisObj.preload.eventQueue;

		thisObj.preload.loaded = true;
		thisObj.setOrg();
		commonJS.callArrayOfFunctions(eventQueue);
	},
	
	
	/**
	 * Loads the salesforce library
	 */
	 "loadLibrary": function(){
		var commonJS = __gh__webApp.common;
		var salesforceID = __gh__coreData["3rdPartyData"].analytics.salesforce.id;
		var salesforceCollectUrl = "http://"+salesforceID+".collect.igodigital.com/collect.js";
			commonJS.loadScript({
				"async":false,
				"src": salesforceCollectUrl,
				"onload": this.onload
			});
	},
	
	
	/**
	 * Sets the salesforce id
	 */
	"setOrg": function(){
		var salesforceID = __gh__coreData["3rdPartyData"].analytics.salesforce.id;
		_etmc.push(["setOrgId", salesforceID]);
	},
	
	/**
	 * Call tracking functions after script has loaded
	 * @param {array} callbacks - array of callback objects 
	 * @example
	 * salesforce.track([{"callback":"__gh__webApp.analytics.salesforce.trackArticle","data":articleObject}])
	 */
	"track": function(trackObj){
		var thisObj 	= __gh__webApp.analytics.salesforce,
			commonJS 	= __gh__webApp.common; 
		if(thisObj.preload.loaded){
	        commonJS.callArrayOfFunctions([trackObj]);
	        return;
	    }
	    thisObj.preload.eventQueue.push(trackObj);
	},
	
	
	/**
	 * Default tracking
	 */
	"trackDefault": function(){
		var trackObj 	= {
				"callback": function(){
					var currentPage = __gh__webApp.currentPage,
						salesforce	= __gh__webApp.analytics.salesforce;
					if (currentPage.isSection()){ salesforce.trackSection(); return; }
					if (currentPage.isArticle() || currentPage.isSearch()){ return; }
					_etmc.push(["trackPageView"]);
				}
			};
		
		this.track(trackObj);
		
	},
	
	
	/**
	 * Article tracking
	 */
	"trackArticle": function(articleObject){
		if (this.isDisabled()) {return;}

		var trackObj 	= {
				"data": articleObject,
				"callback": function(articleObject){
					var commonJS 	= __gh__webApp.common,
						item 		= {
							"item": articleObject.id,
							"name": articleObject.title,
							"item_type": "content",
							"category": articleObject.category,
							"ContentImageLink": "",
							"url": articleObject.link,
							"author": articleObject.bylineFormat.commaDelimited,
							"content_type": "article",
							"publication_date": articleObject.pubDateFormat['yyyy-mm-dd'],
							"available": "Y",
							"keywords": articleObject.keywords
						};
					
					if (commonJS.isObjectPropertySet(articleObject, "image.link")){
						item.image_url = articleObject.image.link;
					}

					if (commonJS.isObjectPropertySet(articleObject, "salesforcePI")){
						item.available = articleObject.salesforcePI;
					}

					_etmc.push(["updateItem",item]);
					
					_etmc.push(["trackPageView", {
					   "item" : articleObject.id 
					}]);
				}
	
			};
		
		this.track(trackObj);
	},
	
	
	/**
	 * Newsletter Sign Up tracking
	 */
	"trackNewsletterSignUp": function(email){
		if (this.isDisabled()) {return;}
		
		var trackObj 	= {
				"data": email,
				"callback": function(email){
					_etmc.push(["setUserInfo", {"email" : email}]);
					_etmc.push(["trackPageView"]);
				}
	
			};
		
		this.track(trackObj);
	},
	
	
	/**
	 * Search tracking
	 */
	"trackSearch": function(searchText){
		if (this.isDisabled()) {return;}
		
		var trackObj 	= {
				"data": searchText,
				"callback": function(searchText){
					_etmc.push(["trackPageView", { "search" : searchText }]); 
				}
	
			};
		
		this.track(trackObj);
	},
	
	
	/**
	 * Section tracking
	 */
	"trackSection": function(){
		var trackObj 	= {
				"callback": function(){
					var category = __gh__coreData.pageData.categoryName;
					_etmc.push(["trackPageView", { "category" : category }]);
				}
	
			};
		
		this.track(trackObj);
		 
	},
	
	
	/**
	 * Social tracking
	 */
	"trackSocial": function(shareData){
		if (this.isDisabled()) {return;}
		
		var trackObj 	= {
				"data":shareData,
				"callback": function(shareData){
					var articleObject = $(shareData.node).closest("[data-article-object]").data("article-object");
					_etmc.push(["trackEvent", { "name": shareData.service, "details" : { "share" : articleObject.guid } }]);

				}
	
			};

		this.track(trackObj);
	}
};
